export default __webpack_public_path__ + "notes-illustration.webp";